// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { IReportResultResponseDto } from './IReportResultResponseDto';
import {
    IReportResultResponseDtoFromJSON,
    IReportResultResponseDtoFromJSONTyped,
    IReportResultResponseDtoToJSON,
    IReportResultResponseDtoToJSONTyped,
} from './IReportResultResponseDto';

/**
 * 
 * @export
 * @interface IPageReportResultResponseDto
 */
export interface IPageReportResultResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPageReportResultResponseDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageReportResultResponseDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageReportResultResponseDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IReportResultResponseDto>}
     * @memberof IPageReportResultResponseDto
     */
    content?: Array<IReportResultResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageReportResultResponseDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageReportResultResponseDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageReportResultResponseDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageReportResultResponseDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportResultResponseDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportResultResponseDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageReportResultResponseDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageReportResultResponseDto interface.
 */
export function instanceOfIPageReportResultResponseDto(value: object): value is IPageReportResultResponseDto {
    return true;
}

export function IPageReportResultResponseDtoFromJSON(json: any): IPageReportResultResponseDto {
    return IPageReportResultResponseDtoFromJSONTyped(json, false);
}

export function IPageReportResultResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageReportResultResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IReportResultResponseDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageReportResultResponseDtoToJSON(json: any): IPageReportResultResponseDto {
    return IPageReportResultResponseDtoToJSONTyped(json, false);
}

export function IPageReportResultResponseDtoToJSONTyped(value?: IPageReportResultResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IReportResultResponseDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

